
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <p>{{text}}<br/><i v-if="sub === 'true'">注：该商品为虚拟商品不支持退换货</i></p>
      <div class="btn-box">
        <button class="f-l btn cancel" @click="cancelHandle()">{{leftName}}</button>
        <button class="f-r btn sure" @click="sureHandle()">{{rightName}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '设置未保存，确定退出？'
    },
    rightName: {
      type: String,
      default: '确定'
    },
    leftName: {
      type: String,
      default: '取消'
    },
    sub: {
      type: String,
      default: 'false'
    }
  },
  name: 'TtipSelect',
  methods: {
    cancelHandle () {
      this.$emit('cancel')
    },
    sureHandle () {
      this.$emit('sure')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999999
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    border-radius 10px
    colmCenter()
    p
      line-height 21px
      font-size 15px
      color #333333
      text-align center
      border-bottom 1px solid #ededed
      padding 12px 36px
      i
       font-size 12px
       color #bbbbbb
    .btn-box
      .btn
        width 50%
        height 57px
        color #333333
        background #ffffff
        font-size 16px
        box-sizing border-box
      .cancel
        border-bottom-left-radius 10px
        border-right 1px solid #ededed
      .sure
        border-bottom-right-radius 10px
        color #334f5f
</style>


// WEBPACK FOOTER //
// src/components/TtipSelect/TtipSelect.vue